module.exports = __webpack_public_path__ + "media/images/map/marker-dot-active-588b704d20904343797f685659f8764b.png";